<template>
  <v-container
    class="selector"
  >
    <v-row class="ma-0 pa-0">
      <v-col cols="12" lg="5" md="5" sm="12" class="available-col">
        <v-subheader>
          <Paginator
            :prev_dsbl="(filters.date && today === filters.date) || (!filters.date && (page === today || available.length <= 0)) || loader"
            :next_dsbl="(!filters.date && available.length <= 0) || loader"
            @changed="a => page_(a)"
          >
            {{ lang.scheduler.new.widget.selector.available.title }}
          </Paginator>
        </v-subheader>
        <v-container
          ref="availableScrollbar"
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
          class="available"
          :class="{ loading }"
        >
          <div style="min-height: 70px;">
            <template v-if="!loading">
              <template v-if="available.length > 0">
                <v-row
                  v-for="(schedule, i) in available"
                  :key="i"
                  @click="toggleSelected(schedule)"
                  class="available-row"
                  :class="{ 'selected': getSelected(schedule.start) }"
                >
                  <v-col cols="6" class="time" :class="`${schedule.color}--text text--lighten-4`">
                    {{ formatTime(schedule.time) }}
                  </v-col>
                  <v-col cols="6" class="schedule">
                    <span :class="`${schedule.color}--text text--lighten-5`">{{ formatDate(schedule.date, false) }}</span>
                    <p>{{ schedule.duration }} min</p>
                  </v-col>
                  <v-col cols="12" class="employees">
                    <span
                      v-for="(employee, i_) in schedule.av_employees"
                      :key="i_"
                      class="employee"
                    >
                      <div class="employee-content">
                        <div class="employee-thumb">
                          <Avatar
                            :photo="employee.avatar"
                            :size="25"
                          />
                        </div>
                        <div class="employee-name">
                          {{ employee.name }}
                        </div>
                      </div>
                    </span>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <span class="no-results">{{ lang.scheduler.new.widget.selector.available.no_results }}</span>
              </template>
            </template>
          </div>
        </v-container>
      </v-col>
      <v-col cols="12" lg="7" md="7" sm="12" class="selected-col">
        <v-subheader>{{ lang.scheduler.new.widget.selector.selected.title }}</v-subheader>
        <v-container
          v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
          class="selected"
          :class="{ 'no-selected': (hasError(1, 0) && value.length <= 0) }"
        >
          <div>
            <template v-if="value.length > 0">
              <v-row
                v-for="(selected, i) in value"
                :key="i"
                class="selected-row"
                :class="{ 'not-validated': (selected.employees || []).length <= 0}"
              >
                <v-col cols="4" class="schedule">
                  <p>
                    <v-icon small>mdi-calendar</v-icon>
                    {{ formatDate(selected.date, false) }}
                  </p>
                  <p>
                    <v-icon small>mdi-clock-time-four-outline</v-icon>
                    {{ formatTime(selected.time) }}
                  </p>
                  <p>
                    <v-icon small>mdi-timer-sand</v-icon>
                    {{ selected.duration }} min
                  </p>
                </v-col>
                <v-col cols="7" class="employees">
                  <template v-if="typeof selected.saved === 'undefined'">
                    <Employees
                      v-model="selected.employees"
                      :employees="selected.av_employees || []"
                      :services_in="services_in"
                      :loading="get_interface.loading || loading"
                    />
                    <div class="employees-chips">
                      <template v-if="(selected.employees || []).length > 0">
                        <v-chip
                          v-for="(employee, i_) in selected.employees"
                          :key="i_"
                          close
                          @click:close="removeEmployee(selected, employee)"
                          class="employee-chip"
                        >
                          <Avatar
                            :photo="employee.avatar"
                            :size="15"
                            class="mr-2"
                          />
                          <span>{{ employee.name }}</span>
                        </v-chip>
                      </template>
                      <template v-else>
                        <span class="no-employees">
                          {{ lang.scheduler.new.widget.selector.selected.no_employees }}
                        </span>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <v-subheader v-text="lang.scheduler.new.widget.filters.employees.title" />
                    <EmployeesCard :value="selected.employees" fullHeight />
                  </template>
                </v-col>
                <v-col cols="1" class="deselect">
                  <v-icon class="schedule-deselect" @click="deselect(selected)">mdi-close</v-icon>
                </v-col>
              </v-row>
            </template>
            <template v-else-if="hasError(1, 0)">
              <span class="no-selected">
                <v-icon color="red">{{ (!is_mobile ? 'mdi-arrow-left-bold' : 'mdi-arrow-up-bold') }}</v-icon><br/>
                {{ lang.scheduler.new.widget.selector.selected.no_selected }}
              </span>
            </template>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Paginator from '@/components/utils/MiniPaginator'
import Avatar from '@/components/users/templates/Avatar'
//import Scheduler from '@/components/scheduler/modules/worker'
import { Scheduler } from '@/components/scheduler/modules/scheduler.js'
import Employees from '../autocomplete/MiniEmployees'
import EmployeesCard from '@/components/scheduler/launches/templates/Employees'
import SchedulerWorker from '@/components/scheduler/modules/worker'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import { format, addDays, subDays } from 'date-fns'

export default {
  components: { Paginator, Avatar, Employees, EmployeesCard },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    filters: {
      type: Object,
      required: true
    },
    loader: {
      type: Boolean,
      default: true
    },
    services_in: {
      type: Array,
      default: () => {
        return []
      }
    },
    others: {
      type: Array,
      default: () => {
        return []
      }
    },
    errors: {
      type: Array,
      default: () => {
        return []
      }
    },
    edit: {
      type: Boolean,
      default: false
    },
    UUID: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      available: [],
      selected: [],
      timeOut: null,
      today: this.getDate_(false),
      page: 0
    }
  },
  computed: {
    loading: {
      get () {
        return this.loader
      },
      set (newVal) {
        this.$emit('loader', newVal)
      }
    },
    all_selected () {
      this.others
      this.selected
      let others = JSON.parse(JSON.stringify(this.others)) || [],
          selected = JSON.parse(JSON.stringify([ ...this.selected ])) || []
      others = others
        .filter(oth => typeof oth.delete === 'undefined' || oth.delete === 0)
        .map(oth => {
          oth.employees = [ ...oth.employees ].map(emp => (typeof emp.id !== 'undefined' ? emp.id : emp))
          return oth
        })
      selected = selected.map(std => {
        std.employees = [ ...std.employees ].map(emp => emp.id)
        return std
      })
      return [ ...others, ...selected ]
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
          this.$emit('input', [ ...newVal ])
        }
        this.getAvailable(this.filters, this.page)
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.selected)) {
          this.selected = [ ...newVal ]
          this.$forceUpdate()
        }
      }
    },
    filters: {
      deep: true,
      immediate: true,
      handler (newVal) {
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(function () {
          this.page = 0
          this.getAvailable(newVal)
        }.bind(this), 1000)
      }
    },
    page (newVal) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(function () {
        this.getAvailable(this.filters, newVal)
      }.bind(this), 500)
    }
  },
  methods: {
    getAvailable (filters, start = 0) {
      this.$emit('loader', true)
      // this.$nextTick(() => {
        /* From Module */
        let tools = new Scheduler(
          this.get_data.employees || [],
          (this.get_data.schedules || {}).all,
          filters || {},
          this.all_selected,
          this.UUID
        ),
        available = tools.available(start) || []
        if (available) {
          this.$set(this, 'available', [ ...available ])
          this.loading = false
          if (this.$refs.availableScrollbar) this.$vuebar.refreshScrollbar(this.$refs.availableScrollbar, { preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true })
        }
        /* From Worker 
        Scheduler.available({
          employees: this.get_data.employees || [],
          schedules: (this.get_data.schedules || {}).all,
          filters: filters || {},
          others: this.all_selected,
          start,
          UUID: this.UUID
        }).then(available => {
          if (available) {
            this.$nextTick(() => {
              this.$set(this, 'available', [ ...available ])
              // this.available = [ ...available ]
              this.loading = false
              if (this.$refs.availableScrollbar) this.$vuebar.refreshScrollbar(this.$refs.availableScrollbar, { preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true })
            })
          }
        })
        /* */
      // })
    },
    hasError (cod, UUID) {
      return (this.errors || []).find(err => err.cod === cod && err.UUID === UUID) || false
    },
    getSelected (start) {
      var selected = [ ...this.selected ]
      return (selected.find(works => works.start === start) || false)
    },
    removeEmployee (item, employee) {
      var selected = [ ...this.selected ]
      const slct = selected.find(works => works.UUID === item.UUID) || false
      if (slct) {
        const empl = slct.employees.find(emp => emp.id === employee.id)
        let index = slct.employees.indexOf(empl)
        if (index >= 0) slct.employees.splice(index, 1)
      }
      this.selected = [ ...selected ]
    },
    toggleSelected (item) {
      var selected = [ ...this.selected ],
          index = selected.findIndex(std => std.start === item.start)
      if (index > -1) {
        selected.splice(index, 1)
      } else {
        // let new_ = { ...item }
        let new_ = {
          ...item,
          employees: (typeof this.filters.match !== 'undefined' && this.filters.match ? [ ...item.av_employees ] : [])
        }
        selected.push({ ...new_ })
      }
      this.selected = [ ...selected ]
    },
    deselect (item) {
      let selected = [ ...this.selected ],
          slIndex = selected.findIndex(std => std.UUID === item.UUID)
      if (slIndex > -1) selected.splice(slIndex, 1)
      this.selected = [ ...selected ]
    },
    page_ (action = 0) {
      if (this.filters.date) {
        return this.$emit('dayPaginator', action)
      } else if (this.available.length > 0) {
        let firstDate = (this.available[0] || {}).date,
            lastDate = (this.available[(this.available.length - 1)] || {}).date,
            newDate = (action > 0 ? addDays(new Date(Date.parse(lastDate.replace('-','/','g'))), 1) : subDays(new Date(Date.parse(firstDate.replace('-','/','g'))), 1))
        this.page = format(newDate, 'yyyy-MM-dd')
        return true
      }
      return false
    }
  },
  mounted () {
    /* this.$nextTick(() => {
      this.getAvailable(this.filters)
    }) */
  },
  destroyed() {
    SchedulerWorker.terminate && SchedulerWorker.terminate()
  }
}
</script>
